import { h } from "vue";

import type {IconSet, IconProps} from 'vuetify';

import thumbUpIcon from '../customSVGs/thumbUp.vue';
import thumbDownIcon from '../customSVGs/thumbDown.vue';
import downloadFilesIcon from '../customSVGs/downloadFiles.vue';
import downloadFileIcon from "../customSVGs/downloadFile.vue";
import offerPriceArrowIcon from '../customSVGs/offerPriceArrow.vue';
import offerPriceArrowRaiseIcon from '../customSVGs/offerPriceArrowRaise.vue';
import winnerCup from '../customSVGs/winnerCup.vue';
import middleDotIcon from '../customSVGs/middleDot.vue';
import invoice from '../customSVGs/invoice.vue';
import eyeOutlineIcon from "../customSVGs/eyeOutline.vue";
import openLockIcon from "../customSVGs/openLock.vue";
import closedLockIcon from "../customSVGs/closedLock.vue";
import deleteOutlineIcon from "../customSVGs/deleteOutline.vue";
import deleteIcon from "../customSVGs/delete.vue";
import pencilIcon from "../customSVGs/pencil.vue";
import checkSircleSuccess from "../customSVGs/checkSircleSuccess.vue";
import checkSircleFailed from "../customSVGs/checkSircleFailed.vue";
import editItemIcon from "../customSVGs/editItem.vue";
import staffIcon from "../customSVGs/staff.vue";
import checkboxOutline from "../customSVGs/checkbox/checkboxOutline.vue";
import checkboxBlankOutline from "../customSVGs/checkbox/checkboxBlankOutline.vue";
import emptyCalendarIcon from "../customSVGs/emptyCalendar.vue";
import twoInCircleIcon from "../customSVGs/twoInCircle.vue";
import text1Icon from "../customSVGs/text1.vue";
import cloudUpIcon from "../customSVGs/cloudUp.vue";
import listIcon from "../customSVGs/list.vue";
import boolIcon from "../customSVGs/bool.vue";
import fileExcelIcon from "../customSVGs/files/fileExcel.vue";
import fileJpgIcon from "../customSVGs/files/fileJpg.vue";
import filePdfIcon from "../customSVGs/files/filePdf.vue";
import fileWordIcon from "../customSVGs/files/fileWord.vue";
import fileZipIcon from "../customSVGs/files/fileZip.vue";
import fileTxtIcon from "../customSVGs/files/fileTxt.vue";
import fileRtfIcon from "../customSVGs/files/fileRtf.vue";
import fileMp3Icon from "../customSVGs/files/fileMp3.vue";
import fileMp4Icon from "../customSVGs/files/fileMp4.vue";
import info from "../customSVGs/info.vue";

const customSvgNameToComponent = {
  thumbUpIcon,
  thumbDownIcon,
  downloadFileIcon,
  downloadFilesIcon,
  offerPriceArrowIcon,
  offerPriceArrowRaiseIcon,
  middleDotIcon,
  invoice,
  openLockIcon,
  closedLockIcon,
  eyeOutlineIcon,
  deleteIcon,
  deleteOutlineIcon,
  pencilIcon,
  winnerCup,
  checkSircleSuccess,
  checkSircleFailed,
  editItemIcon,
  staffIcon,
  checkboxOutline,
  checkboxBlankOutline,
  emptyCalendarIcon,
  twoInCircleIcon,
  text1Icon,
  cloudUpIcon,
  listIcon,
  boolIcon,
  fileExcelIcon,
  fileJpgIcon,
  filePdfIcon,
  fileWordIcon,
  fileZipIcon,
  fileTxtIcon,
  fileRtfIcon,
  fileMp3Icon,
  fileMp4Icon,
  info,
};

export const iconSet: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon as string]),
};
